import React, { useState } from "react";
import {NavigateFunction, useNavigate, useSearchParams} from 'react-router-dom';
import {useFormik} from "formik";
import * as Yup from "yup";
import { resetPassword } from "../../services/auth.service";
import { Image} from "react-bootstrap";
import IChangePassword from "../../types/authentication/change-password-request.type";
import showNotification from "../utils/Notify";
import {Box, Card, Input, Stack, Button} from "@mui/joy";
import fygLupa from "../../assets/FyG-lupa.png";
import KeyIcon from '@mui/icons-material/Key';

type Props = {}

const ResetPassword: React.FC<Props> = () => {
  let navigate: NavigateFunction = useNavigate();
  const [loading, setLoading] = useState<boolean>(false);
  const [searchParams, setSearchParams] = useSearchParams();
  const token = searchParams.get('token');

  const initialValues: IChangePassword = {
    password: '',
    confirmation: '',
    token: token? token : '',
  };

  const validationSchema = Yup.object().shape({
    password: Yup.string()
      .required('Password is required.')
      .min(8, 'Password must be 8 characters long.')
      .matches(/[0-9]/, 'Password requires a number.')
      .matches(/[a-z]/, 'Password requires a lowercase letter.')
      .matches(/[A-Z]/, 'Password requires an uppercase letter.')
  });

  const onSubmit = (password: IChangePassword) => {
    setLoading(true);
    resetPassword(password)
      .then((response) => {
        showNotification({type: 'success', message: 'Password has been changed successfully.'});
        setLoading(false);
        navigate('/login')
      })
      .catch(error => {
        showNotification({type: 'error', message: error.response.data.message});
        setLoading(false);
      });
  };

  const formik= useFormik({
    enableReinitialize: true,
    initialValues: initialValues,
    onSubmit,
    validationSchema: validationSchema,
  });

  return (
    <Box
      className="App"
      sx={{
        px: { xs: 2},
        pt: { xs: 'calc(12px + var(--Header-height))' },
        flex: 1,
        display: 'flex',
        flexDirection: 'column',
        minWidth: 0,
        height: '100dvh',
        overflow: "auto"
      }}
    >
      <Box sx={{ flex: 1, display: 'flex', alignItems: 'center', justifyContent: 'center'}}>
        <Card sx={{width: 500}}>
          <Stack direction="row" spacing={1} justifyContent="center" p={0} m={0}>
            <Stack direction="column" spacing={0}>
              <span className="Logo-title"><i>F&G TECHNOLOGIES</i></span>
              <span className="Logo-subtitle"><i><u>Gesti&oacute;n Interna</u></i></span>
            </Stack>
            <Image src={fygLupa} alt="FyG Logo" width={100}/>
          </Stack>
          <form className="form" onSubmit={formik.handleSubmit}>
            <Stack spacing={2}>
              <Input
                startDecorator={<KeyIcon/>}
                name="password"
                onBlur={formik.handleBlur}
                onChange={formik.handleChange}
                type="password"
                placeholder="New Password"
                error={!!(formik.touched.password && formik.errors.password)}
                sx={{height: 50}}
              />
              {formik.touched.password && formik.errors.password ? (
                          <span className="Error-alert">{formik.errors.password}</span>
                      ) : null}
              <Button
                type="submit"
                variant="solid"
                className="Button-custom"
                fullWidth
                disabled={loading}
              >
                RESTABLECER CONTRASEÑA
              </Button>
            </Stack>
          </form>
        </Card>

        {/*<Container style={{width: 500}}>*/}

        {/*  <div className="Login-container pb-5 Round-bottom-corners">*/}
        {/*    <form className="form" onSubmit={formik.handleSubmit}>*/}
        {/*      <Form.Group className="form-group pt-3 position-relative" controlId="validationFormikNewPassword">*/}
        {/*        <Form.Label htmlFor="newPassword" className="pb-1 Input-label-custom">*/}
        {/*          New Password*/}
        {/*        </Form.Label>*/}
        {/*        <Form.Control*/}
        {/*          className="form-control Input-custom"*/}
        {/*          name="password"*/}
        {/*          type="password"*/}
        {/*          placeholder="New Password"*/}
        {/*          onChange={formik.handleChange}*/}
        {/*          onBlur={formik.handleBlur}*/}
        {/*          value={formik.values.password}*/}
        {/*        />*/}
        {/*        {formik.touched.password && formik.errors.password ? (*/}
        {/*          <span className="Error-alert">{formik.errors.password}</span>*/}
        {/*        ) : null}*/}
        {/*      </Form.Group>*/}
        {/*      <Form.Group className="form-group pt-3">*/}
        {/*        <Button*/}
        {/*          type="submit"*/}
        {/*          className="btn btn-primary btn-block w-100 h-100 Button-custom Custom-color"*/}
        {/*          disabled={loading}*/}
        {/*        >*/}
        {/*          {loading && (<span className="spinner-border spinner-border-sm"></span>)}*/}
        {/*          <span>Reset Password</span>*/}
        {/*        </Button>*/}
        {/*      </Form.Group>*/}
        {/*    </form>*/}
        {/*  </div>*/}
        {/*</Container>*/}
      </Box>
    </Box>
  );
};

export default ResetPassword;
